const isDevMode = true;
export class MyLog {
    static showLog(message) {
        if (isDevMode)
            console.info(message);
    }
}
